import { Typography } from "components/atoms";
import classNames from "classnames";
import { Modal } from "components/molecules";
import { CloseIcon } from "components/atoms/Icon";
import { StudyPalnFilter } from "components/molecules/StudyPlanFilter";
import "./study-filter-panel.scss";

interface IProps {
  isOpen: boolean;
  handleOnclose: any;
  theme: "light" | "dark";
  displayDate: string;
}

export const SideFilterPanel = ({
  isOpen,
  handleOnclose,
  theme,
  displayDate,
}: IProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={handleOnclose}
      theme={theme}
      style="study-modal-custom-style"
      openOnRight={true}
    >
      <div
        className={classNames({
          "study-side-modal-header-wrapper": true,
        })}
      >
        <div className="close-icon-wrapper">
          <CloseIcon
            theme={theme}
            style="study-side-modal-close-icon"
            onClick={handleOnclose}
          />
        </div>
        <div className="header-content-wrapper">
          <Typography label="Add To Study Plan" variant="h7Bold" />
          <Typography label={displayDate} variant="h8Book" />
        </div>
        <StudyPalnFilter theme={theme} date={displayDate} closeModal={handleOnclose} />
      </div>
    </Modal>
  );
};
